import { mapGetters } from 'vuex';
import constants from '@/constants';

export default {
  computed: {
    ...mapGetters(['getFeatureSwitch']),

    isBreakOutFeatureDisabled() {
      return this.getFeatureSwitch(constants.FEATURE_SWITCHES_TITLES.DISABLE_BREAK_OUT_NOTIFICATION);
    },
  },
};
